import { NotificationSettings, VesselMessage } from '../../../../types/VesselMessage';
import { VesselUpdateRequestMessage } from '../../../../types/VesselUpdateRequestMessage';
import { setRelatedNotificationSettings } from '../EditVessel/utils/setRelatedNotificationSettings';

export interface VesselUpdateRequestValues {
    name: string;
    imo: string;
    types: string[];
    services: string[];
    email: string;
    defaultSupplierId: string;
    defaultContractId: string | null;
    invoiceAddress: {
        companyName: string;
        street: string;
        streetNumber: string;
        zipcode: string;
        city: string;
        country: string;
    };
    postalAddress: {
        companyName: string;
        street: string;
        streetNumber: string;
        zipcode: string;
        city: string;
        country: string;
    };
    vatNumber: string;
    invoiceEmailAddress: string;
    mailNotificationSettings: {
        orderUpdateSettings: NotificationSettings;
        stockWarningSettings: NotificationSettings;
        safetyReserveSettings: NotificationSettings;
        keyPortCallSettings: NotificationSettings;
    };
    lubricationChart: {
        file?: File;
        added: boolean;
        removed: boolean;
    };
    active: boolean;
    paying: boolean;
    directOrderAllowed: boolean;
}

export const toVesselUpdateRequest = (
    vessel: VesselMessage,
    values?: VesselUpdateRequestValues
): VesselUpdateRequestMessage => {
    if (values) {
        return {
            id: vessel.id,
            customerId: vessel.customerId,
            name: values.name,
            imo: values.imo,
            types: values.types.length ? values.types : undefined,
            services: values.services.length ? values.services : undefined,
            email: values.email || undefined,
            defaultSupplierId: values.defaultSupplierId || null,
            defaultContractId: values.defaultContractId || null,
            invoiceAddress: values.invoiceAddress,
            postalAddress: values.postalAddress,
            invoiceVAT: values.vatNumber || undefined,
            invoiceEmailAddress: values.invoiceEmailAddress || undefined,
            lubricationChart: values.lubricationChart,
            active: values.active,
            paying: values.paying,
            directOrderAllowed: values.directOrderAllowed,
            mailNotificationSettings: {
                ...values.mailNotificationSettings,
                orderUpdateSettings: {
                    enabled:
                        values.mailNotificationSettings.orderUpdateSettings.enabled &&
                        values.mailNotificationSettings.orderUpdateSettings.recipients.length > 0,
                    recipients: values.mailNotificationSettings.orderUpdateSettings.recipients,
                    sendToOthers: vessel.mailNotificationSettings.orderUpdateSettings.sendToOthers,
                    sendToVessel: vessel.mailNotificationSettings.orderUpdateSettings.sendToVessel,
                },
                stockWarningSettings: setRelatedNotificationSettings(
                    values.mailNotificationSettings.stockWarningSettings
                ),
                safetyReserveSettings: setRelatedNotificationSettings(
                    values.mailNotificationSettings.safetyReserveSettings
                ),
                keyPortCallSettings: setRelatedNotificationSettings(
                    values.mailNotificationSettings.keyPortCallSettings
                ),
            },
        };
    }

    return {
        id: vessel.id,
        customerId: vessel.customerId,
        name: vessel.name,
        imo: vessel.imo,
        email: vessel.email,
        invoiceVAT: vessel.invoiceVAT,
        invoiceEmailAddress: vessel.invoiceEmailAddress,
        invoiceAddress: vessel.invoiceAddress,
        postalAddress: vessel.postalAddress,
        directOrderAllowed: vessel.directOrderAllowed,
        paying: vessel.paying,
        active: vessel.active,
        defaultSupplierId: vessel.defaultSupplierId ?? null,
        defaultContractId: vessel.defaultContractId ?? null,
        lubricationChart: {
            added: false,
            removed: false,
        },
        services: vessel.services,
        types: vessel.types,
        mailNotificationSettings: vessel.mailNotificationSettings,
    };
};
